import { useState, useCallback } from 'react';
import { message } from 'antd';
import { documentApiService } from '../services/documentApi';

export const useEditDocument = (fetchDocuments) => {
  const [editingDocument, setEditingDocument] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editCompany, setEditCompany] = useState('');
  const [editType, setEditType] = useState('');
  const [editFileName, setEditFileName] = useState('');

  const handleMetadataUpdate = useCallback((record) => {
    setEditingDocument(record);
    setEditFileName(record.name);
    setEditCompany(record.company);
    setEditType(record.type);
    setIsEditModalVisible(true);
  }, []);

  const handleEditModalOk = useCallback(async () => {
    try {
      await documentApiService.updateDocumentMetadata(
        editingDocument.name,
        editFileName,
        editCompany,
        editType
      );
      
      message.success('Document details updated successfully');
      setIsEditModalVisible(false);
      fetchDocuments();
    } catch (error) {
      console.error('Error updating document metadata:', error);
      message.error('Failed to update document details');
    }
  }, [editingDocument, editFileName, editCompany, editType, fetchDocuments]);

  return {
    editingDocument,
    isEditModalVisible,
    setIsEditModalVisible,
    editCompany,
    setEditCompany,
    editType,
    setEditType,
    editFileName,
    setEditFileName,
    handleMetadataUpdate,
    handleEditModalOk,
  };
};